import { useLocation, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import styles from './search.module.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faSpinner } from "@fortawesome/free-solid-svg-icons";

const baseURL = `${process.env.REACT_APP_API_URL}`


const Search = () => {
    const [results, setResults] = useState(null);
    const location = useLocation();
    const query = new URLSearchParams(location.search).get('query')

    useEffect(() => {
        if (query) {
            axios.get(`${baseURL}/profiles/search?query=${query}`)
            .then((response) => {
                setResults(response.data);
                console.log('Search results:', response.data);
            })
            .catch((error) => {
                console.error('Error fetching search results:', error);
            });
        }
    }, [query]);

    if (!results) return (
              <div className={styles.loadingContent}>
                <FontAwesomeIcon icon={faSpinner} spin size="3x" className={styles.spinner} />
                <span className={styles.loadingText}>Loading...</span>
              </div>
            );

    return (
        <div className={styles.searchResultsContainer}>
            <h2 className={styles.searchTitle}>Search Results for "{query}"</h2>
            <div className={styles.resultSection}>
                <h3 className={styles.sectionTitle}>House Managers</h3>
                {results.house_manager.length ? (
                    <div className={styles.cardGrind}>
                        {results.house_manager.map((hm) => (
                            <Link
                                to={`/profile/house_manager/${hm.id}`}
                                key={hm.id}
                                className={styles.resultCard}
                            >
                            <div key={hm.id}>
                                <img 
                                    src={`${baseURL}${hm.image}`}
                                    alt={hm.first_name}
                                    className={styles.resultImage}
                                />
                                <div>
                                    <p className={styles.resultName}>{hm.first_name} {hm.last_name}</p>
                                    <p className={styles.resultLocation}><FontAwesomeIcon icon={faMapMarkerAlt} style={{color: '#007bff'}}/> {hm.location}</p>
                                    <p className={styles.resultLocation}>Available: {hm.availability}</p>
                                </div>
                            </div>
                            </Link>
                            
                        ))}
                    </div>
                ) : (
                    <p className={styles.noResultMessage}>No House Manager Found</p>
                )}
            </div>
            <div className={styles.resultSection}>
                <h3 className={styles.sectionTitle}>Employers</h3>
                {results.employer.length ? (
                    <div className={styles.cardGrind}>
                        {results.employer.map((emp) => (
                            <Link
                                to={`/profile/employer/${emp.id}`}
                                key={emp.id}
                                className={styles.resultCard}
                            >
                            <div key={emp.id}>
                                <img 
                                    src={`${baseURL}${emp.image}`}
                                    alt={emp.first_name}
                                    className={styles.resultImage}
                                />
                                <div>
                                    <p className={styles.resultName}>{emp.first_name} {emp.last_name}</p>
                                    <p className={styles.resultLocation}>{emp.location}</p>
                                    <p className={styles.resultLocation}>{emp.availability}</p>
                                </div>
                            </div>
                            </Link>
                            
                        ))}
                    </div>
                ) : (
                    <p className={styles.noResultMessage}>No House Manager Found</p>
                )}
            </div>
        </div>
    );
};

export default Search;